import type { Note } from '../../api/types'

/** Shown wherever a note has no title of its own. Mirrors the server default. */
export const UNTITLED_NOTE_TITLE = 'Untitled'

export function noteTitle(note: Note): string {
  return note.title.trim() || UNTITLED_NOTE_TITLE
}

/** First non-empty line of the body, stripped of markdown noise, for list rows. */
export function notePreview(note: Note): string {
  const line = note.content
    .split('\n')
    .map((l) => l.replace(/^[#>\-*\s[\]x]+/i, '').trim())
    .find((l) => l.length > 0)
  return line ?? 'Empty note'
}

/** "just now" / "14:32" / "Tue" / "Mar 3" — enough to place a note in time. */
export function formatNoteTime(iso: string): string {
  const then = new Date(iso)
  const diffMs = Date.now() - then.getTime()
  if (diffMs < 60_000) return 'just now'

  const startOfToday = new Date()
  startOfToday.setHours(0, 0, 0, 0)
  if (then >= startOfToday) {
    return then.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }

  const sixDaysAgo = new Date(startOfToday)
  sixDaysAgo.setDate(sixDaysAgo.getDate() - 6)
  if (then >= sixDaysAgo) return then.toLocaleDateString([], { weekday: 'short' })

  return then.toLocaleDateString([], { month: 'short', day: 'numeric' })
}
